import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_COLLECTION_ITEM } from '../../pluginKeys';
import CollectionElementItem from './components/CollectionElementItem';
import { CollectionItemPluginOptions } from './types';

export const createCollectionItemPlugin = createTElementPluginFactory<CollectionItemPluginOptions>({
  key: ELEMENT_COLLECTION_ITEM,
  component: CollectionElementItem,
});
